import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentEntities } from "../PaymentEntities";

export interface PaymentViewPageProps extends NSARouterMakerResult, PaymentProps
{ }

function PaymentViewPage(props: PaymentViewPageProps)
{
    return (
        <PaymentLayout {...props}
            action={{
                title: "",
                description: "Review detailed information about a specific payment.",
                menus: {}
            }}
            pages={{
                entity: PaymentEntities.Payment(props),
                view: {}
            }}
        >
            <>
            </>
        </ PaymentLayout>

    );
}

export default PaymentViewPage;